import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {FormsModule}   from '@angular/forms';

import { AppComponent } from './app.component';
import {AppRoutingModule} from "./app-routing.module";
import {LoginComponent} from "./login/login.component";
import {IndexComponent} from "./index/index.component";
import {SearchComponent} from "./search/search.component";
import {AuthenticationService} from "./_services/authentication.service";
import {HttpModule} from "@angular/http";
import {AboutComponent} from "./about/about.component";
import {AuthGuard} from "./_guards/auth.guard";
import {LogoutComponent} from "./logout/logout.component";
import {FooterComponent} from "./_directives/footer.component";
import {ContactComponent} from "./contact/contact.component";
import {NotFoundComponent} from "./error/404.component";
import {SearchService} from "./_services/search.service";
import {SpinnerComponent} from "./_directives/spinner/spinner.component";

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        IndexComponent,
        SearchComponent,
        AboutComponent,
        LogoutComponent,
        FooterComponent,
        ContactComponent,
        NotFoundComponent,
        SpinnerComponent,
    ],
    imports: [
        BrowserModule,
        HttpModule,
        AppRoutingModule,
        FormsModule,
    ],
    providers: [
        AuthenticationService,
        SearchService,
        AuthGuard,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/odQvAFzU/0/heba/118365/src/main/frontend/src/app/app.module.ts